import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 底材列表
export const setBaseMatList: Mutation<IModuleState> = (state, payload) => {
  state.baseMatList.data = payload.data;
  state.baseMatList.loading = !!payload.loading;
};

// 底材详情
export const setBaseMatDetail: Mutation<IModuleState> = (state, payload) => {
  state.baseMatDetail.data = payload.data;
  state.baseMatDetail.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
